import { View } from 'react-native';

import { Box, VStack, theme } from '@squire/ui';

import { Skeleton } from '@/components/_shared/Skeleton';

import { styles } from './styles';
import type { ChooseTimeCalendarSkeletonProps } from './types';

// ChooseTimeCalendar shows the selected day plus the following five, then the
// month-picker button — seven cells in all.
const VISIBLE_DAYS = 6;

const ChooseTimeCalendarSkeleton = ({
  testID,
}: ChooseTimeCalendarSkeletonProps) => {
  return (
    <View style={styles.daysRow} testID={testID}>
      {Array.from({ length: VISIBLE_DAYS }).map((_, index) => (
        <VStack key={index} style={styles.day} space={theme.spacing[3]}>
          <View style={styles.dayCircle}>
            <Skeleton
              variant="circular"
              style={styles.dayCircleSkeleton}
              testID={testID ? `${testID}-day-${index}` : undefined}
            />
          </View>

          <View style={styles.dayLabel}>
            <Skeleton variant="text" width={24} height={12} />
          </View>
        </VStack>
      ))}

      <Box style={styles.openCalendarButtonContainer}>
        <Skeleton
          variant="circular"
          style={styles.openCalendarButton}
          testID={testID ? `${testID}-open-calendar-button` : undefined}
        />
      </Box>
    </View>
  );
};

ChooseTimeCalendarSkeleton.displayName = 'ChooseTimeCalendarSkeleton';

export { ChooseTimeCalendarSkeleton };
